<script>
import { mapActions, mapGetters } from 'vuex'
import capitalize from 'lodash/capitalize'
import { formatDate } from '@lib/utils/format-date'
import formatDollar from '@lib/utils/format-dollar'

export default {
  name: 'FloatTransactionDetails',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      transaction: {},
      loading: true,
    }
  },
  computed: {
    ...mapGetters('me', [
      'showFloat',
    ]),
    backRoute() {
      return { name: 'float-transaction-ledger' }
    },
    status() {
      if (this.loading) {
        return null
      }

      const { status } = this.transaction

      switch (status) {
        case 'pending':
          return {
            icon: 'time',
            label: 'Pending',
            color: '#fbb241',
          }
        case 'completed':
          return {
            icon: 'success',
            label: 'Completed',
            color: '#29d737',
          }
        case 'failed':
          return {
            icon: 'error',
            label: 'Failed',
            color: '#fc7168',
          }
        default:
          return {}
      }
    },
  },
  async created() {
    // if (!this.showFloat) {
    //   this.$router.replace('/')
    // }

    const { id } = this

    const ledger = await this.getFloatLedger(id)

    if (ledger[0]) {
      this.transaction = ledger[0]
    } else {
      this.$router.replace(this.backRoute)
    }

    this.loading = false
  },
  methods: {
    ...mapActions('float', {
      getFloatLedger: 'GET_FLOAT_LEDGER',
      getFloat: 'GET_FLOAT',
    }),
    capitalize,
    formatDate,
    formatDollar,
  },
}
</script>

<template>
  <main-layout
    :title="`Float Transaction ${id}`"
    :back="backRoute"
    :loading="loading"
  >
    <template v-if="transaction.id">
      <data-box
        header="Transaction Details"
        :status="status"
        :class="$style.transactionDetails"
      >
        <data-list>
          <dt>Date Created</dt>
          <dd>
            {{
              transaction.created_at
                ? formatDate(transaction.created_at, 'DD.MM.YYYY hh:mm')
                : '-'
            }}
          </dd>

          <dt>Description</dt>
          <dd>{{ transaction.description || '-' }}</dd>

          <dt>Claim No</dt>
          <dd>{{ transaction.metadata && transaction.metadata.claim_number || '-' }}</dd>

          <dt>Amount</dt>
          <dd>{{ formatDollar(transaction.amount.total) }}</dd>

          <dt>Fee</dt>
          <dd>{{ formatDollar(transaction.amount.payment_fee) }}</dd>

          <dt>Net</dt>
          <dd>{{ formatDollar(transaction.amount.subtotal) }}</dd>

          <dt>Transaction</dt>
          <dd>{{ transaction.transaction_id }}</dd>

          <dt>Date Finalised</dt>
          <dd>
            {{
              transaction.finalised_at
                ? formatDate(transaction.finalised_at, 'DD.MM.YYYY hh:mm')
                : '-'
            }}
          </dd>
        </data-list>
      </data-box>

      <data-box
        header="Payment Details"
        :status="null"
      >
        <data-list>
          <dt>Payment Method</dt>
          <dd>{{ transaction.payment_source.pan }}</dd>
        </data-list>
      </data-box>
    </template>
  </main-layout>
</template>

<style module>
.transactionDetails {
  margin-bottom: 2rem;
}
</style>
